{
  "AF": {
    "name": "Afghanistan",
    "countryCode": "AF",
    "currencyCode": "AFN",
    "locale": "ps-AF"
  },
  "AL": {
    "name": "Albania",
    "countryCode": "AL",
    "currencyCode": "ALL",
    "locale": "sq-AL"
  },
  "DZ": {
    "name": "Algeria",
    "countryCode": "DZ",
    "currencyCode": "DZD",
    "locale": "ar-DZ"
  },
  "AS": {
    "name": "American Samoa",
    "countryCode": "AS",
    "currencyCode": "USD",
    "locale": "en-AS"
  },
  "AD": {
    "name": "Andorra",
    "countryCode": "AD",
    "currencyCode": "EUR",
    "locale": "ca"
  },
  "AO": {
    "name": "Angola",
    "countryCode": "AO",
    "currencyCode": "AOA",
    "locale": "pt"
  },
  "AI": {
    "name": "Anguilla",
    "countryCode": "AI",
    "currencyCode": "XCD",
    "locale": "en"
  },
  "AQ": {
    "name": "Antarctica",
    "countryCode": "AQ",
    "currencyCode": "USD",
    "locale": "en-US"
  },
  "AG": {
    "name": "Antigua and Barbuda",
    "countryCode": "AG",
    "currencyCode": "XCD",
    "locale": "en"
  },
  "AR": {
    "name": "Argentina",
    "countryCode": "AR",
    "currencyCode": "ARS",
    "locale": "es-AR"
  },
  "AM": {
    "name": "Armenia",
    "countryCode": "AM",
    "currencyCode": "AMD",
    "locale": "hy-AM"
  },
  "AW": {
    "name": "Aruba",
    "countryCode": "AW",
    "currencyCode": "AWG",
    "locale": "nl"
  },
  "AU": {
    "name": "Australia",
    "countryCode": "AU",
    "currencyCode": "AUD",
    "locale": "en-AU"
  },
  "AT": {
    "name": "Austria",
    "countryCode": "AT",
    "currencyCode": "EUR",
    "locale": "de-AT"
  },
  "AZ": {
    "name": "Azerbaijan",
    "countryCode": "AZ",
    "currencyCode": "AZN",
    "locale": "az-Cyrl-AZ"
  },
  "BS": {
    "name": "Bahamas",
    "countryCode": "BS",
    "currencyCode": "BSD",
    "locale": "en"
  },
  "BH": {
    "name": "Bahrain",
    "countryCode": "BH",
    "currencyCode": "BHD",
    "locale": "ar-BH"
  },
  "BD": {
    "name": "Bangladesh",
    "countryCode": "BD",
    "currencyCode": "BDT",
    "locale": "bn-BD"
  },
  "BB": {
    "name": "Barbados",
    "countryCode": "BB",
    "currencyCode": "BBD",
    "locale": "en"
  },
  "BY": {
    "name": "Belarus",
    "countryCode": "BY",
    "currencyCode": "BYN",
    "locale": "be-BY"
  },
  "BE": {
    "name": "Belgium",
    "countryCode": "BE",
    "currencyCode": "EUR",
    "locale": "nl-BE"
  },
  "BZ": {
    "name": "Belize",
    "countryCode": "BZ",
    "currencyCode": "BZD",
    "locale": "en-BZ"
  },
  "BJ": {
    "name": "Benin",
    "countryCode": "BJ",
    "currencyCode": "XOF",
    "locale": "fr-BJ"
  },
  "BM": {
    "name": "Bermuda",
    "countryCode": "BM",
    "currencyCode": "BMD",
    "locale": "en"
  },
  "BT": {
    "name": "Bhutan",
    "countryCode": "BT",
    "currencyCode": "BTN",
    "locale": "dz"
  },
  "BO": {
    "name": "Bolivia",
    "countryCode": "BO",
    "currencyCode": "BTN",
    "locale": "es-BO"
  },
  "BQ": {
    "name": "Bonaire",
    "countryCode": "BQ",
    "currencyCode": "USD",
    "locale": "nl"
  },
  "BA": {
    "name": "Bosnia and Herzegovina",
    "countryCode": "BA",
    "currencyCode": "BAM",
    "locale": "bs-BA"
  },
  "BW": {
    "name": "Botswana",
    "countryCode": "BW",
    "currencyCode": "BWP",
    "locale": "en-BW"
  },
  "BV": {
    "name": "Bouvet Island",
    "countryCode": "BV",
    "currencyCode": "NOK",
    "locale": "no"
  },
  "BR": {
    "name": "Brazil",
    "countryCode": "BR",
    "currencyCode": "BRL",
    "locale": "pt-BR"
  },
  "IO": {
    "name": "British Indian Ocean Territory",
    "countryCode": "IO",
    "currencyCode": "USD",
    "locale": "en"
  },
  "BN": {
    "name": "Brunei Darussalam",
    "countryCode": "BN",
    "currencyCode": "BND",
    "locale": "ms-BN"
  },
  "BG": {
    "name": "Bulgaria",
    "countryCode": "BG",
    "currencyCode": "BGN",
    "locale": "bg-BG"
  },
  "BF": {
    "name": "Burkina Faso",
    "countryCode": "BF",
    "currencyCode": "XOF",
    "locale": "fr-BF"
  },
  "BI": {
    "name": "Burundi",
    "countryCode": "BI",
    "currencyCode": "BIF",
    "locale": "fr-BI"
  },
  "CV": {
    "name": "Cabo Verde",
    "countryCode": "CV",
    "currencyCode": "CVE",
    "locale": "kea-CV"
  },
  "KH": {
    "name": "Cambodia",
    "countryCode": "KH",
    "currencyCode": "KHR",
    "locale": "km-KH"
  },
  "CM": {
    "name": "Cameroon",
    "countryCode": "CM",
    "currencyCode": "XAF",
    "locale": "fr-CM"
  },
  "CA": {
    "name": "Canada",
    "countryCode": "CA",
    "currencyCode": "CAD",
    "locale": "en-CA"
  },
  "KY": {
    "name": "Cayman Islands",
    "countryCode": "KY",
    "currencyCode": "KYD",
    "locale": "en"
  },
  "CF": {
    "name": "Central African Republic",
    "countryCode": "CF",
    "currencyCode": "XAF",
    "locale": "fr-CF"
  },
  "TD": {
    "name": "Chad",
    "countryCode": "TD",
    "currencyCode": "XAF",
    "locale": "fr-TD"
  },
  "CL": {
    "name": "Chile",
    "countryCode": "CL",
    "currencyCode": "CLF",
    "locale": "es-CL"
  },
  "CN": {
    "name": "China",
    "countryCode": "CN",
    "currencyCode": "CNY",
    "locale": "zh-CN"
  },
  "CX": {
    "name": "Christmas Island",
    "countryCode": "CX",
    "currencyCode": "AUD",
    "locale": "en"
  },
  "CC": {
    "name": "Cocos Islands",
    "countryCode": "CC",
    "currencyCode": "AUD",
    "locale": "en"
  },
  "CO": {
    "name": "Colombia",
    "countryCode": "CO",
    "currencyCode": "COU",
    "locale": "es-CO"
  },
  "KM": {
    "name": "Comoros",
    "countryCode": "KM",
    "currencyCode": "KMF",
    "locale": "fr-KM"
  },
  "CD": {
    "name": "Democratic Republic of the Congo",
    "countryCode": "CD",
    "currencyCode": "CDF",
    "locale": "fr-CD"
  },
  "CG": {
    "name": "Congo",
    "countryCode": "CG",
    "currencyCode": "XAF",
    "locale": "fr-CG"
  },
  "CK": {
    "name": "Cook Islands",
    "countryCode": "CK",
    "currencyCode": "NZD",
    "locale": "en"
  },
  "CR": {
    "name": "Costa Rica",
    "countryCode": "CR",
    "currencyCode": "CRC",
    "locale": "es-CR"
  },
  "HR": {
    "name": "Croatia",
    "countryCode": "HR",
    "currencyCode": "HRK",
    "locale": "hr-HR"
  },
  "CU": {
    "name": "Cuba",
    "countryCode": "CU",
    "currencyCode": "CUC",
    "locale": "es"
  },
  "CW": {
    "name": "Curaçao",
    "countryCode": "CW",
    "currencyCode": "ANG",
    "locale": "nl"
  },
  "CY": {
    "name": "Cyprus",
    "countryCode": "CY",
    "currencyCode": "EUR",
    "locale": "el-CY"
  },
  "CZ": {
    "name": "Czechia",
    "countryCode": "CZ",
    "currencyCode": "CZK",
    "locale": "cs-CZ"
  },
  "CI": {
    "name": "Côte d'Ivoire",
    "countryCode": "CI",
    "currencyCode": "CZK",
    "locale": "fr-CI"
  },
  "DK": {
    "name": "Denmark",
    "countryCode": "DK",
    "currencyCode": "DKK",
    "locale": "da-DK"
  },
  "DJ": {
    "name": "Djibouti",
    "countryCode": "DJ",
    "currencyCode": "DJF",
    "locale": "fr-DJ"
  },
  "DM": {
    "name": "Dominica",
    "countryCode": "DM",
    "currencyCode": "XCD",
    "locale": "en"
  },
  "DO": {
    "name": "Dominican Republic",
    "countryCode": "DO",
    "currencyCode": "DOP",
    "locale": "es-DO"
  },
  "EC": {
    "name": "Ecuador",
    "countryCode": "EC",
    "currencyCode": "USD",
    "locale": "es-EC"
  },
  "EG": {
    "name": "Egypt",
    "countryCode": "EG",
    "currencyCode": "EGP",
    "locale": "ar-EG"
  },
  "SV": {
    "name": "El Salvador",
    "countryCode": "SV",
    "currencyCode": "USD",
    "locale": "es-SV"
  },
  "GQ": {
    "name": "Equatorial Guinea",
    "countryCode": "GQ",
    "currencyCode": "XAF",
    "locale": "fr-GQ"
  },
  "ER": {
    "name": "Eritrea",
    "countryCode": "ER",
    "currencyCode": "ERN",
    "locale": "ti-ER"
  },
  "EE": {
    "name": "Estonia",
    "countryCode": "EE",
    "currencyCode": "EUR",
    "locale": "et-EE"
  },
  "SZ": {
    "name": "Eswatini",
    "countryCode": "SZ",
    "currencyCode": "EUR",
    "locale": "en"
  },
  "ET": {
    "name": "Ethiopia",
    "countryCode": "ET",
    "currencyCode": "ETB",
    "locale": "am-ET"
  },
  "FK": {
    "name": "Falkland Islands",
    "countryCode": "FK",
    "currencyCode": "DKK",
    "locale": "en"
  },
  "FO": {
    "name": "Faroe Islands",
    "countryCode": "FO",
    "currencyCode": "DKK",
    "locale": "fo-FO"
  },
  "FJ": {
    "name": "Fiji",
    "countryCode": "FJ",
    "currencyCode": "FJD",
    "locale": "en"
  },
  "FI": {
    "name": "Finland",
    "countryCode": "FI",
    "currencyCode": "EUR",
    "locale": "fi-FI"
  },
  "FR": {
    "name": "France",
    "countryCode": "FR",
    "currencyCode": "EUR",
    "locale": "fr-FR"
  },
  "GF": {
    "name": "French Guiana",
    "countryCode": "GF",
    "currencyCode": "EUR",
    "locale": "fr"
  },
  "PF": {
    "name": "French Polynesia",
    "countryCode": "PF",
    "currencyCode": "XPF",
    "locale": "fr"
  },
  "TF": {
    "name": "French Southern Territories",
    "countryCode": "TF",
    "currencyCode": "EUR",
    "locale": "fr"
  },
  "GA": {
    "name": "Gabon",
    "countryCode": "GA",
    "currencyCode": "XAF",
    "locale": "fr-GA"
  },
  "GM": {
    "name": "Gambia",
    "countryCode": "GM",
    "currencyCode": "GMD",
    "locale": "en"
  },
  "GE": {
    "name": "Georgia",
    "countryCode": "GE",
    "currencyCode": "GEL",
    "locale": "ka-GE"
  },
  "DE": {
    "name": "Germany",
    "countryCode": "DE",
    "currencyCode": "EUR",
    "locale": "de-DE"
  },
  "GH": {
    "name": "Ghana",
    "countryCode": "GH",
    "currencyCode": "GHS",
    "locale": "ak-GH"
  },
  "GI": {
    "name": "Gibraltar",
    "countryCode": "GI",
    "currencyCode": "GIP",
    "locale": "en"
  },
  "GR": {
    "name": "Greece",
    "countryCode": "GR",
    "currencyCode": "EUR",
    "locale": "el-GR"
  },
  "GL": {
    "name": "Greenland",
    "countryCode": "GL",
    "currencyCode": "DKK",
    "locale": "kl-GL"
  },
  "GD": {
    "name": "Grenada",
    "countryCode": "GD",
    "currencyCode": "XCD",
    "locale": "en"
  },
  "GP": {
    "name": "Guadeloupe",
    "countryCode": "GP",
    "currencyCode": "EUR",
    "locale": "fr-GP"
  },
  "GU": {
    "name": "Guam",
    "countryCode": "GU",
    "currencyCode": "USD",
    "locale": "en-GU"
  },
  "GT": {
    "name": "Guatemala",
    "countryCode": "GT",
    "currencyCode": "GTQ",
    "locale": "es-GT"
  },
  "GG": {
    "name": "Guernsey",
    "countryCode": "GG",
    "currencyCode": "GBP",
    "locale": "en"
  },
  "GN": {
    "name": "Guinea",
    "countryCode": "GN",
    "currencyCode": "GNF",
    "locale": "fr-GN"
  },
  "GW": {
    "name": "Guinea-Bissau",
    "countryCode": "GW",
    "currencyCode": "XOF",
    "locale": "pt-GW"
  },
  "GY": {
    "name": "Guyana",
    "countryCode": "GY",
    "currencyCode": "GYD",
    "locale": "en"
  },
  "HT": {
    "name": "Haiti",
    "countryCode": "HT",
    "currencyCode": "USD",
    "locale": "fr"
  },
  "HM": {
    "name": "Heard Island and McDonald Islands",
    "countryCode": "HM",
    "currencyCode": "AUD",
    "locale": "en"
  },
  "VA": {
    "name": "Holy See",
    "countryCode": "VA",
    "currencyCode": "EUR",
    "locale": "it"
  },
  "HN": {
    "name": "Honduras",
    "countryCode": "HN",
    "currencyCode": "HNL",
    "locale": "es-HN"
  },
  "HK": {
    "name": "Hong Kong",
    "countryCode": "HK",
    "currencyCode": "HKD",
    "locale": "en-HK"
  },
  "HU": {
    "name": "Hungary",
    "countryCode": "HU",
    "currencyCode": "HUF",
    "locale": "hu-HU"
  },
  "IS": {
    "name": "Iceland",
    "countryCode": "IS",
    "currencyCode": "ISK",
    "locale": "is-IS"
  },
  "IN": {
    "name": "India",
    "countryCode": "IN",
    "currencyCode": "INR",
    "locale": "hi-IN"
  },
  "ID": {
    "name": "Indonesia",
    "countryCode": "ID",
    "currencyCode": "IDR",
    "locale": "id-ID"
  },
  "IR": {
    "name": "Iran",
    "countryCode": "IR",
    "currencyCode": "XDR",
    "locale": "fa-IR"
  },
  "IQ": {
    "name": "Iraq",
    "countryCode": "IQ",
    "currencyCode": "IQD",
    "locale": "ar-IQ"
  },
  "IE": {
    "name": "Ireland",
    "countryCode": "IE",
    "currencyCode": "EUR",
    "locale": "en-IE"
  },
  "IM": {
    "name": "Isle of Man",
    "countryCode": "IM",
    "currencyCode": "GBP",
    "locale": "en"
  },
  "IL": {
    "name": "Israel",
    "countryCode": "IL",
    "currencyCode": "ILS",
    "locale": "he-IL"
  },
  "IT": {
    "name": "Italy",
    "countryCode": "IT",
    "currencyCode": "EUR",
    "locale": "it-IT"
  },
  "JM": {
    "name": "Jamaica",
    "countryCode": "JM",
    "currencyCode": "JMD",
    "locale": "en-JM"
  },
  "JP": {
    "name": "Japan",
    "countryCode": "JP",
    "currencyCode": "JPY",
    "locale": "ja-JP"
  },
  "JE": {
    "name": "Jersey",
    "countryCode": "JE",
    "currencyCode": "GBP",
    "locale": "en"
  },
  "JO": {
    "name": "Jordan",
    "countryCode": "JO",
    "currencyCode": "JOD",
    "locale": "ar-JO"
  },
  "KZ": {
    "name": "Kazakhstan",
    "countryCode": "KZ",
    "currencyCode": "KZT",
    "locale": "kk-Cyrl-KZ"
  },
  "KE": {
    "name": "Kenya",
    "countryCode": "KE",
    "currencyCode": "KES",
    "locale": "ebu-KE"
  },
  "KI": {
    "name": "Kiribati",
    "countryCode": "KI",
    "currencyCode": "AUD",
    "locale": "en"
  },
  "KP": {
    "name": "North Korea",
    "countryCode": "KP",
    "currencyCode": "KPW",
    "locale": "ko"
  },
  "KR": {
    "name": "South Korea",
    "countryCode": "KR",
    "currencyCode": "USD",
    "locale": "ko-KR"
  },
  "KW": {
    "name": "Kuwait",
    "countryCode": "KW",
    "currencyCode": "KWD",
    "locale": "ar-KW"
  },
  "KG": {
    "name": "Kyrgyzstan",
    "countryCode": "KG",
    "currencyCode": "KGS",
    "locale": "ky"
  },
  "LA": {
    "name": "Lao People's Democratic Republic",
    "countryCode": "LA",
    "currencyCode": "LAK",
    "locale": "lo"
  },
  "LV": {
    "name": "Latvia",
    "countryCode": "LV",
    "currencyCode": "EUR",
    "locale": "lv-LV"
  },
  "LB": {
    "name": "Lebanon",
    "countryCode": "LB",
    "currencyCode": "LBP",
    "locale": "ar-LB"
  },
  "LS": {
    "name": "Lesotho",
    "countryCode": "LS",
    "currencyCode": "ZAR",
    "locale": "en"
  },
  "LR": {
    "name": "Liberia",
    "countryCode": "LR",
    "currencyCode": "LRD",
    "locale": "en"
  },
  "LY": {
    "name": "Libya",
    "countryCode": "LY",
    "currencyCode": "LYD",
    "locale": "ar-LY"
  },
  "LI": {
    "name": "Liechtenstein",
    "countryCode": "LI",
    "currencyCode": "CHF",
    "locale": "de-LI"
  },
  "LT": {
    "name": "Lithuania",
    "countryCode": "LT",
    "currencyCode": "EUR",
    "locale": "lt-LT"
  },
  "LU": {
    "name": "Luxembourg",
    "countryCode": "LU",
    "currencyCode": "EUR",
    "locale": "fr-LU"
  },
  "MO": {
    "name": "Macao",
    "countryCode": "MO",
    "currencyCode": "MOP",
    "locale": "zh-Hans-MO"
  },
  "MG": {
    "name": "Madagascar",
    "countryCode": "MG",
    "currencyCode": "MGA",
    "locale": "fr-MG"
  },
  "MW": {
    "name": "Malawi",
    "countryCode": "MW",
    "currencyCode": "MWK",
    "locale": "en"
  },
  "MY": {
    "name": "Malaysia",
    "countryCode": "MY",
    "currencyCode": "MYR",
    "locale": "ms-MY"
  },
  "MV": {
    "name": "Maldives",
    "countryCode": "MV",
    "currencyCode": "MVR",
    "locale": "dv"
  },
  "ML": {
    "name": "Mali",
    "countryCode": "ML",
    "currencyCode": "XOF",
    "locale": "fr-ML"
  },
  "MT": {
    "name": "Malta",
    "countryCode": "MT",
    "currencyCode": "EUR",
    "locale": "en-MT"
  },
  "MH": {
    "name": "Marshall Islands",
    "countryCode": "MH",
    "currencyCode": "USD",
    "locale": "en-MH"
  },
  "MQ": {
    "name": "Martinique",
    "countryCode": "MQ",
    "currencyCode": "EUR",
    "locale": "fr-MQ"
  },
  "MR": {
    "name": "Mauritania",
    "countryCode": "MR",
    "currencyCode": "MRU",
    "locale": "ar"
  },
  "MU": {
    "name": "Mauritius",
    "countryCode": "MU",
    "currencyCode": "MUR",
    "locale": "en-MU"
  },
  "YT": {
    "name": "Mayotte",
    "countryCode": "YT",
    "currencyCode": "EUR",
    "locale": "fr"
  },
  "MX": {
    "name": "Mexico",
    "countryCode": "MX",
    "currencyCode": "MXV",
    "locale": "es-MX"
  },
  "FM": {
    "name": "Micronesia",
    "countryCode": "FM",
    "currencyCode": "RUB",
    "locale": "en"
  },
  "MD": {
    "name": "Moldova",
    "countryCode": "MD",
    "currencyCode": "MDL",
    "locale": "ro-MD"
  },
  "MC": {
    "name": "Monaco",
    "countryCode": "MC",
    "currencyCode": "EUR",
    "locale": "fr-MC"
  },
  "MN": {
    "name": "Mongolia",
    "countryCode": "MN",
    "currencyCode": "MNT",
    "locale": "mn"
  },
  "ME": {
    "name": "Montenegro",
    "countryCode": "ME",
    "currencyCode": "EUR",
    "locale": "sr-Cyrl-ME"
  },
  "MS": {
    "name": "Montserrat",
    "countryCode": "MS",
    "currencyCode": "XCD",
    "locale": "en"
  },
  "MA": {
    "name": "Morocco",
    "countryCode": "MA",
    "currencyCode": "MAD",
    "locale": "ar-MA"
  },
  "MZ": {
    "name": "Mozambique",
    "countryCode": "MZ",
    "currencyCode": "MZN",
    "locale": "pt-MZ"
  },
  "MM": {
    "name": "Myanmar",
    "countryCode": "MM",
    "currencyCode": "MMK",
    "locale": "my-MM"
  },
  "NA": {
    "name": "Namibia",
    "countryCode": "NA",
    "currencyCode": "ZAR",
    "locale": "en-NA"
  },
  "NR": {
    "name": "Nauru",
    "countryCode": "NR",
    "currencyCode": "AUD",
    "locale": "en"
  },
  "NP": {
    "name": "Nepal",
    "countryCode": "NP",
    "currencyCode": "NPR",
    "locale": "ne-NP"
  },
  "NL": {
    "name": "Netherlands",
    "countryCode": "NL",
    "currencyCode": "EUR",
    "locale": "nl-NL"
  },
  "AN": {
    "name": "Netherlands Antilles",
    "countryCode": "AN",
    "currencyCode": "ANG",
    "locale": "nl-AN"
  },
  "NC": {
    "name": "New Caledonia",
    "countryCode": "NC",
    "currencyCode": "XPF",
    "locale": "fr"
  },
  "NZ": {
    "name": "New Zealand",
    "countryCode": "NZ",
    "currencyCode": "NZD",
    "locale": "en-NZ"
  },
  "NI": {
    "name": "Nicaragua",
    "countryCode": "NI",
    "currencyCode": "NIO",
    "locale": "es-NI"
  },
  "NE": {
    "name": "Niger",
    "countryCode": "NE",
    "currencyCode": "XOF",
    "locale": "fr-NE"
  },
  "NG": {
    "name": "Nigeria",
    "countryCode": "NG",
    "currencyCode": "NGN",
    "locale": "ha-Latn-NG"
  },
  "NU": {
    "name": "Niue",
    "countryCode": "NU",
    "currencyCode": "NZD",
    "locale": "en"
  },
  "NF": {
    "name": "Norfolk Island",
    "countryCode": "NF",
    "currencyCode": "AUD",
    "locale": "en"
  },
  "MK": {
    "name": "North Macedonia",
    "countryCode": "MK",
    "currencyCode": "AUD",
    "locale": "mk-MK"
  },
  "MP": {
    "name": "Northern Mariana Islands",
    "countryCode": "MP",
    "currencyCode": "USD",
    "locale": "en-MP"
  },
  "NO": {
    "name": "Norway",
    "countryCode": "NO",
    "currencyCode": "NOK",
    "locale": "nb-NO"
  },
  "OM": {
    "name": "Oman",
    "countryCode": "OM",
    "currencyCode": "OMR",
    "locale": "ar-OM"
  },
  "PK": {
    "name": "Pakistan",
    "countryCode": "PK",
    "currencyCode": "PKR",
    "locale": "en-PK"
  },
  "PW": {
    "name": "Palau",
    "countryCode": "PW",
    "currencyCode": "USD",
    "locale": "en"
  },
  "PS": {
    "name": "Palestine",
    "countryCode": "PS",
    "currencyCode": "USD",
    "locale": "ar"
  },
  "PA": {
    "name": "Panama",
    "countryCode": "PA",
    "currencyCode": "USD",
    "locale": "es-PA"
  },
  "PG": {
    "name": "Papua New Guinea",
    "countryCode": "PG",
    "currencyCode": "PGK",
    "locale": "en"
  },
  "PY": {
    "name": "Paraguay",
    "countryCode": "PY",
    "currencyCode": "PYG",
    "locale": "es-PY"
  },
  "PE": {
    "name": "Peru",
    "countryCode": "PE",
    "currencyCode": "PEN",
    "locale": "es-PE"
  },
  "PH": {
    "name": "Philippines",
    "countryCode": "PH",
    "currencyCode": "PHP",
    "locale": "en-PH"
  },
  "PN": {
    "name": "Pitcairn",
    "countryCode": "PN",
    "currencyCode": "NZD",
    "locale": "en"
  },
  "PL": {
    "name": "Poland",
    "countryCode": "PL",
    "currencyCode": "PLN",
    "locale": "pl-PL"
  },
  "PT": {
    "name": "Portugal",
    "countryCode": "PT",
    "currencyCode": "EUR",
    "locale": "pt-PT"
  },
  "PR": {
    "name": "Puerto Rico",
    "countryCode": "PR",
    "currencyCode": "USD",
    "locale": "es-PR"
  },
  "QA": {
    "name": "Qatar",
    "countryCode": "QA",
    "currencyCode": "QAR",
    "locale": "ar-QA"
  },
  "RO": {
    "name": "Romania",
    "countryCode": "RO",
    "currencyCode": "RON",
    "locale": "ro-RO"
  },
  "RU": {
    "name": "Russia",
    "countryCode": "RU",
    "currencyCode": "RUB",
    "locale": "ru-RU"
  },
  "RW": {
    "name": "Rwanda",
    "countryCode": "RW",
    "currencyCode": "RWF",
    "locale": "fr-RW"
  },
  "RE": {
    "name": "Réunion",
    "countryCode": "RE",
    "currencyCode": "RWF",
    "locale": "fr-RE"
  },
  "BL": {
    "name": "Saint Barthélemy",
    "countryCode": "BL",
    "currencyCode": "EUR",
    "locale": "fr-BL"
  },
  "SH": {
    "name": "Saint Helena",
    "countryCode": "SH",
    "currencyCode": "SHP",
    "locale": "en"
  },
  "KN": {
    "name": "Saint Kitts and Nevis",
    "countryCode": "KN",
    "currencyCode": "XCD",
    "locale": "en"
  },
  "LC": {
    "name": "Saint Lucia",
    "countryCode": "LC",
    "currencyCode": "XCD",
    "locale": "en"
  },
  "MF": {
    "name": "Saint Martin",
    "countryCode": "MF",
    "currencyCode": "EUR",
    "locale": "fr-MF"
  },
  "PM": {
    "name": "Saint Pierre and Miquelon",
    "countryCode": "PM",
    "currencyCode": "EUR",
    "locale": "fr"
  },
  "VC": {
    "name": "Saint Vincent and the Grenadines",
    "countryCode": "VC",
    "currencyCode": "XCD",
    "locale": "en"
  },
  "WS": {
    "name": "Samoa",
    "countryCode": "WS",
    "currencyCode": "WST",
    "locale": "sm"
  },
  "SM": {
    "name": "San Marino",
    "countryCode": "SM",
    "currencyCode": "EUR",
    "locale": "it"
  },
  "ST": {
    "name": "Sao Tome and Principe",
    "countryCode": "ST",
    "currencyCode": "STN",
    "locale": "pt"
  },
  "SA": {
    "name": "Saudi Arabia",
    "countryCode": "SA",
    "currencyCode": "SAR",
    "locale": "ar-SA"
  },
  "SN": {
    "name": "Senegal",
    "countryCode": "SN",
    "currencyCode": "XOF",
    "locale": "fr-SN"
  },
  "RS": {
    "name": "Serbia",
    "countryCode": "RS",
    "currencyCode": "RSD",
    "locale": "sr-Cyrl-RS"
  },
  "SC": {
    "name": "Seychelles",
    "countryCode": "SC",
    "currencyCode": "SCR",
    "locale": "fr"
  },
  "SL": {
    "name": "Sierra Leone",
    "countryCode": "SL",
    "currencyCode": "SLL",
    "locale": "en"
  },
  "SG": {
    "name": "Singapore",
    "countryCode": "SG",
    "currencyCode": "SGD",
    "locale": "en-SG"
  },
  "SX": {
    "name": "Sint Maarten",
    "countryCode": "SX",
    "currencyCode": "ANG",
    "locale": "nl"
  },
  "SK": {
    "name": "Slovakia",
    "countryCode": "SK",
    "currencyCode": "EUR",
    "locale": "sk-SK"
  },
  "SI": {
    "name": "Slovenia",
    "countryCode": "SI",
    "currencyCode": "EUR",
    "locale": "sl-SI"
  },
  "SB": {
    "name": "Solomon Islands",
    "countryCode": "SB",
    "currencyCode": "SBD",
    "locale": "en"
  },
  "SO": {
    "name": "Somalia",
    "countryCode": "SO",
    "currencyCode": "SOS",
    "locale": "so-SO"
  },
  "ZA": {
    "name": "South Africa",
    "countryCode": "ZA",
    "currencyCode": "ZAR",
    "locale": "af-ZA"
  },
  "GS": {
    "name": "South Georgia and the South Sandwich Islands",
    "countryCode": "GS",
    "currencyCode": "USD",
    "locale": "en"
  },
  "SS": {
    "name": "South Sudan",
    "countryCode": "SS",
    "currencyCode": "SSP",
    "locale": "en"
  },
  "ES": {
    "name": "Spain",
    "countryCode": "ES",
    "currencyCode": "EUR",
    "locale": "es-ES"
  },
  "LK": {
    "name": "Sri Lanka",
    "countryCode": "LK",
    "currencyCode": "LKR",
    "locale": "si-LK"
  },
  "SD": {
    "name": "Sudan",
    "countryCode": "SD",
    "currencyCode": "SDG",
    "locale": "ar-SD"
  },
  "SR": {
    "name": "Suriname",
    "countryCode": "SR",
    "currencyCode": "SRD",
    "locale": "nl"
  },
  "SJ": {
    "name": "Svalbard and Jan Mayen",
    "countryCode": "SJ",
    "currencyCode": "NOK",
    "locale": "no"
  },
  "SE": {
    "name": "Sweden",
    "countryCode": "SE",
    "currencyCode": "SEK",
    "locale": "sv-SE"
  },
  "CH": {
    "name": "Switzerland",
    "countryCode": "CH",
    "currencyCode": "CHW",
    "locale": "fr-CH"
  },
  "SY": {
    "name": "Syrian Arab Republic",
    "countryCode": "SY",
    "currencyCode": "SYP",
    "locale": "ar-SY"
  },
  "TW": {
    "name": "Taiwan",
    "countryCode": "TW",
    "currencyCode": "TWD",
    "locale": "zh-Hant-TW"
  },
  "TJ": {
    "name": "Tajikistan",
    "countryCode": "TJ",
    "currencyCode": "TJS",
    "locale": "tg"
  },
  "TZ": {
    "name": "Tanzania",
    "countryCode": "TZ",
    "currencyCode": "TZS",
    "locale": "asa-TZ"
  },
  "TH": {
    "name": "Thailand",
    "countryCode": "TH",
    "currencyCode": "THB",
    "locale": "th-TH"
  },
  "TL": {
    "name": "Timor-Leste",
    "countryCode": "TL",
    "currencyCode": "USD",
    "locale": "pt"
  },
  "TG": {
    "name": "Togo",
    "countryCode": "TG",
    "currencyCode": "XOF",
    "locale": "fr-TG"
  },
  "TK": {
    "name": "Tokelau",
    "countryCode": "TK",
    "currencyCode": "NZD",
    "locale": "en"
  },
  "TO": {
    "name": "Tonga",
    "countryCode": "TO",
    "currencyCode": "TOP",
    "locale": "to-TO"
  },
  "TT": {
    "name": "Trinidad and Tobago",
    "countryCode": "TT",
    "currencyCode": "TTD",
    "locale": "en-TT"
  },
  "TN": {
    "name": "Tunisia",
    "countryCode": "TN",
    "currencyCode": "TND",
    "locale": "ar-TN"
  },
  "TR": {
    "name": "Turkey",
    "countryCode": "TR",
    "currencyCode": "TRY",
    "locale": "tr-TR"
  },
  "TM": {
    "name": "Turkmenistan",
    "countryCode": "TM",
    "currencyCode": "TMT",
    "locale": "tk"
  },
  "TC": {
    "name": "Turks and Caicos Islands",
    "countryCode": "TC",
    "currencyCode": "USD",
    "locale": "en"
  },
  "TV": {
    "name": "Tuvalu",
    "countryCode": "TV",
    "currencyCode": "AUD",
    "locale": "en"
  },
  "UG": {
    "name": "Uganda",
    "countryCode": "UG",
    "currencyCode": "UGX",
    "locale": "cgg-UG"
  },
  "UA": {
    "name": "Ukraine",
    "countryCode": "UA",
    "currencyCode": "UAH",
    "locale": "uk-UA"
  },
  "AE": {
    "name": "United Arab Emirates",
    "countryCode": "AE",
    "currencyCode": "AED",
    "locale": "ar-AE"
  },
  "GB": {
    "name": "United Kingdom",
    "countryCode": "GB",
    "currencyCode": "GBP",
    "locale": "en-GB"
  },
  "UM": {
    "name": "United States Minor Outlying Islands",
    "countryCode": "UM",
    "currencyCode": "USD",
    "locale": "en-UM"
  },
  "US": {
    "name": "United States",
    "countryCode": "US",
    "currencyCode": "USD",
    "locale": "en-US"
  },
  "UY": {
    "name": "Uruguay",
    "countryCode": "UY",
    "currencyCode": "UYU",
    "locale": "es-UY"
  },
  "UZ": {
    "name": "Uzbekistan",
    "countryCode": "UZ",
    "currencyCode": "UZS",
    "locale": "uz-Cyrl-UZ"
  },
  "VU": {
    "name": "Vanuatu",
    "countryCode": "VU",
    "currencyCode": "VUV",
    "locale": "bi"
  },
  "VE": {
    "name": "Venezuela",
    "countryCode": "VE",
    "currencyCode": "VUV",
    "locale": "es-VE"
  },
  "VN": {
    "name": "Viet Nam",
    "countryCode": "VN",
    "currencyCode": "VND",
    "locale": "vi-VN"
  },
  "VG": {
    "name": "Virgin Islands (British)",
    "countryCode": "VG",
    "currencyCode": "USD",
    "locale": "en"
  },
  "VI": {
    "name": "Virgin Islands (U.S.)",
    "countryCode": "VI",
    "currencyCode": "USD",
    "locale": "en-VI"
  },
  "WF": {
    "name": "Wallis and Futuna",
    "countryCode": "WF",
    "currencyCode": "XPF",
    "locale": "fr"
  },
  "EH": {
    "name": "Western Sahara",
    "countryCode": "EH",
    "currencyCode": "MAD",
    "locale": "es"
  },
  "YE": {
    "name": "Yemen",
    "countryCode": "YE",
    "currencyCode": "YER",
    "locale": "ar-YE"
  },
  "ZM": {
    "name": "Zambia",
    "countryCode": "ZM",
    "currencyCode": "ZMW",
    "locale": "bem-ZM"
  },
  "ZW": {
    "name": "Zimbabwe",
    "countryCode": "ZW",
    "currencyCode": "ZWL",
    "locale": "en-ZW"
  },
  "AX": {
    "name": "Åland Islands",
    "countryCode": "AX",
    "currencyCode": "EUR",
    "locale": "sv"
  },
  "XK": {
    "name": "Kosovo",
    "countryCode": "XK",
    "currencyCode": "EUR",
    "locale": "sq"
  }
}